import React from "react";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";


const BspGuidelines = () => {
  return (
    <Container>
    <h2 className="display-6 fw-bold my-4">BSP Guidelines on Artificial Intelligence and Authorship
    </h2>
    <hr />

    <p className="joab-common-para my-4">The introduction of generative artificial intelligence tools creates new opportunities while also challenging the concept of authorship. As a leading scholarly publisher, we have been following these developments attentively.</p>

    <p className="joab-common-para my-4" >Our updated guidelines on authorship recognize that tools such as AI chatbots (e.g., ChatGPT) and other large language models (LLMs) <b>do not meet authorship criteria</b> and therefore cannot be listed as authors on manuscripts. While AI can contribute intellectually to the writing process, it is now widely accepted that it <b> cannot take responsibility </b> for the content it produces.</p>

    <p className="joab-common-para my-4">Authors are <b>fully responsible</b> for the originality, validity, and integrity of their manuscript and must ensure that it complies with all of  <b>BSP’s </b>publication ethics policies.</p>
    <p className="joab-common-para my-4">AI technology can still be used in writing academic papers, but its use must be  <b>appropriately declared</b> when submitting a paper to a  <b>BSP</b> journal. Authors are required to be <b>fully transparent</b> by:</p>

  
    <ul className="joab-common-para my-4">
        <li className="mb-2">Stating <b>  which tools were used</b>in the “Acknowledgments” section. </li>

        <li className="mb-2">Describing <b>how AI tools were used</b> in the “Materials and Methods” section.</li>
       
    </ul>


    <p className="joab-common-para my-4">Our new guideline aligns with the <b>Committee on Publication Ethics (COPE)</b> position statement on the use of AI and AI-assisted technology in manuscript preparation. COPE emphasizes that <b>“authors are fully responsible for the content of their manuscript, even those parts produced by an AI tool, and are thus liable for any breach of publication ethics.”</b></p>
   


  </Container>
  );
};

export default BspGuidelines;
